/**
 * Month/period formatting shared by the grid's Period column and the action
 * drawer, so the two can't disagree on how a status run reads.
 */

/** "Feb 2026"-style month label; UTC so the first-of-month date can't shift. */
export function formatPeriodMonth(iso: string): string {
  return new Date(iso).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    timeZone: "UTC",
  });
}

/**
 * The months an exceedance's status run spans: "Feb 2026 – May 2026",
 * collapsing to a single month when the run is one month (or on legacy rows with
 * no lastPeriodStart yet).
 */
export function formatPeriodSpan(row: {
  periodStart: string;
  lastPeriodStart?: string | null;
}): string {
  const first = formatPeriodMonth(row.periodStart);
  const last = row.lastPeriodStart ? formatPeriodMonth(row.lastPeriodStart) : first;
  return first === last ? first : `${first} – ${last}`;
}
